import React from 'react';
//import { CircularProgress } from '@mui/material';
import { grey } from '@mui/material/colors';
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import LogoCargando from '../../Activos/Imagenes/LogoCargando.svg';
/*import AnimacionCargando from '../../Activos/Imagenes/Animacion/LoadingClass.json';*/
import { useStateValue } from '../../Contexto/store';
import { ColorFondoPrimario } from '../../Componentes/Tool/PaletaColores'

//import Lottie from 'react-lottie-player'

const PREFIX = 'MyLoading';
const classes = {
    position: `${PREFIX}-position`,
    buttonProgress: `${PREFIX}-buttonProgress`
}
const Root = styled('div')(({ theme }) => ({
    [`&.${classes.position}`]: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'absolute',
        top: '30%',
        left: '50%',
        transform: 'translateX(-50%)',
        '& > * + *': {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        }
    },
    [`& .${classes.buttonProgress}`]: {
        color: grey[500],
        size: 48
    }
}))

export const MyDialog = () => {
    const [{ cargandoRed }] = useStateValue();
    return (
        <Dialog open={cargandoRed.LoadHome} fullScreen >
            <div style={{ position: 'relative', top: '0', bottom: '0', left: '0', right: '0', width: '100%', height: '100%', backgroundColor: ColorFondoPrimario }} >
                <Root className={classes.position} >
                    {/*<img src={classImage} alt="Class Limitless" height={80} />*/}
                    <img src={LogoCargando} alt={"Cargando"} style={{ margin: "0px 0px 20px 0px" }} />
                    {/*<Lottie*/}
                    {/*    loop*/}
                    {/*    animationData={AnimacionCargando}*/}
                    {/*    play*/}
                    {/*    style={{ width: 150, height: 150, marginBottom: '10px' }}*/}
                    {/*/>*/}
                    <span>{cargandoRed.texto}</span>
                    {/*<CircularProgress className={classes.buttonProgress} />*/}
                </Root>
            </div>
        </Dialog>
    );
}
